import { ValidationErrors } from '@angular/forms';
import { WorkspaceDatabaseKeys } from '@database/workspace';
import { AppRoutingKeys, fileBooleanMappings } from '@shared';
import { firstValueFrom, of } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';
import { ValidationKeys } from '../../models';
import { IntervalService } from '../../services/interval.service';
import { IAsyncValidatorHandler } from '../async-validator-handler.interface';
import { CrossTableParams } from '../models/cross-table-params-type';

export class OverlapCheck implements IAsyncValidatorHandler {
	private next: IAsyncValidatorHandler;

	public constructor(private intervalService: IntervalService) {}

	public setNext(nextHandler: IAsyncValidatorHandler) {
		this.next = nextHandler;
	}

	public async handle(crossTableParams: CrossTableParams): Promise<ValidationErrors | null> {
		const overlapCheck: ValidationErrors | null = await firstValueFrom(
			of(fileBooleanMappings[crossTableParams.tableMetadata[WorkspaceDatabaseKeys.tables.allowOverlap]]).pipe(
				switchMap((allowOverlap: boolean) => {
					if (!allowOverlap) {
						// Extract params
						const qp = crossTableParams.queryParamsMap;
						const tableName = qp.get(AppRoutingKeys.queryParamsMap.tableName);
						const workfileId = qp.get(AppRoutingKeys.queryParamsMap.workfileId);
						const projectNumber = qp.get(AppRoutingKeys.queryParamsMap.projectNumber);
						const entityName = qp.get(AppRoutingKeys.queryParamsMap.entityName);
						const entryId = qp.get(AppRoutingKeys.queryParamsMap.entryId);
						const childEntryId = qp.get(AppRoutingKeys.queryParamsMap.childEntryId);

						// Use BOTH depthFrom and depthTo correctly:
						const depthFrom = crossTableParams.crossControlKey === WorkspaceDatabaseKeys.columns.depthFrom
							? crossTableParams.crossControlValue
							: crossTableParams.controlValue;

						const depthTo = crossTableParams.crossControlKey === WorkspaceDatabaseKeys.columns.depthTo
							? crossTableParams.crossControlValue
							: crossTableParams.controlValue;

						return this.intervalService.isOverlappingData$(
							tableName,
							workfileId,
							projectNumber,
							entityName,
							entryId,
							childEntryId,
							depthFrom,
							depthTo
						).pipe(
							map((overlapFound: boolean) => {
								if (overlapFound) {
									return {
										[ValidationKeys.validationRules.intervalOverlapRule]: true
									};
								}
								return null;
							})
						);
					}
				 return of(null);
				})
			)
		);

		if (overlapCheck) {
		 return overlapCheck;
		}

		if (this.next) {
		 return await this.next.handle(crossTableParams);
		}

		return null;
	}
}